import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { activate as activateThunk, clearAuthError } from 'store/slices/authSlice';
import AuthPage from 'components/layout/AuthPage/AuthPage';
import { TextInputField } from 'components/forms';
import { PrimaryButton, Link } from 'components/buttons/';
import TimedRedirect from 'components/layout/TimedRedirect/TimedRedirect';

function Activate() {
  const dispatch = useDispatch();
  const { loading, error, status } = useSelector((state) => state.auth);
  const { register, handleSubmit, formState: { errors, isDirty } } = useForm();
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token');
  const triedAutoActivation = React.useRef(false);

  // If token in URL, trigger activation on mount (only once)
  useEffect(() => {
    if (tokenFromUrl && !triedAutoActivation.current) {
      triedAutoActivation.current = true;
      dispatch(activateThunk(tokenFromUrl));
    }
    return () => { dispatch(clearAuthError()); };
  }, [tokenFromUrl, dispatch]);

  // Form submit handler
  const onSubmit = (data) => {
    dispatch(activateThunk(data.token));
  };

  const renderActivateForm = () => (
    <>
      {tokenFromUrl && loading && (
        <div className="text-center text-lg text-indigo-400 mb-4">Activating your account...</div>
      )}
      {tokenFromUrl && (
        <div className="mt-6 text-gray-300">If you have another token, you can use the form below.</div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={`space-y-6${tokenFromUrl ? ' mt-4' : ''}`}>
        <TextInputField
          name="token"
          register={register}
          registerOptions={{
            required: 'Activation token is required',
          }}
          errors={errors}
          placeholder="Activation Token"
          labelText="Activation Token"
        />

        <div>
          <PrimaryButton
            type="submit"
            disabled={loading || !isDirty}
            className="flex w-full justify-center"
          >
            {loading ? 'Activating...' : 'Activate'}
          </PrimaryButton>
        </div>
      </form>
      <div className="flex w-full justify items-center justify-between">
        <p className="mt-10 text-center text-sm/6 text-gray-400">
          Not a member?{' '}
          <Link to="/register">Register</Link>
        </p>
        <p className="mt-10 text-center text-sm/6 text-gray-400">
          Already activated?{' '}
          <Link to="/login">Login</Link>
        </p>
      </div>
    </>
  );

  return (
    <AuthPage title="Activate account" error={error}>
      {
        status
        ? <TimedRedirect url="/login" message={status} />
        : renderActivateForm()
      }
    </AuthPage>
  );
}

export default Activate;
